import { waLink } from "@/lib/site";
import { Reveal } from "@/components/Reveal";
import { GoldDivider } from "@/components/GoldDivider";
import { useLang } from "@/i18n";

const U = (id) => `${id}?auto=format&fit=crop&w=600&q=80`;

const PRODUCT_IMAGES = [
    U("https://images.unsplash.com/photo-1600181982553-ce7d36051c01"),
    U("https://images.unsplash.com/photo-1613750255797-7d4f877615df"),
    "/images/shop/velas-pasillo.jpg",
    U("https://images.unsplash.com/photo-1612800083994-d568da6256ba"),
    "/images/shop/cristales.jpg",
    U("https://images.unsplash.com/photo-1640794296019-ab6b5de045c2"),
    U("https://images.unsplash.com/photo-1579101451346-4d0cd752f4b8"),
    U("https://images.unsplash.com/photo-1623645424873-22b02991bdaf"),
    U("https://images.unsplash.com/photo-1534976618208-4833d5b57d08"),
];

export const Products = () => {
    const { t } = useLang();
    const names = t("products.items");

    return (
        <section id="productos" data-testid="products-section" className="relative py-24 sm:py-32 px-5 sm:px-8 bg-ink-deep overflow-hidden">
            <div
                className="absolute inset-0 pointer-events-none candle-glow"
                style={{ background: "radial-gradient(ellipse 50% 35% at 88% 15%, rgba(212,175,55,0.08) 0%, transparent 65%)" }}
                aria-hidden="true"
            />
            <div className="absolute top-0 left-0 right-0 h-28 section-fade-top" aria-hidden="true" />
            <div className="absolute bottom-0 left-0 right-0 h-28 section-fade-bottom" aria-hidden="true" />

            <div className="relative max-w-6xl mx-auto">
                <Reveal className="text-center mb-14">
                    <p className="font-accent text-[11px] tracking-[0.4em] uppercase text-gold-soft mb-4">
                        {t("products.eyebrow")}
                    </p>
                    <h2 className="font-display font-semibold gold-text text-4xl sm:text-5xl tracking-wide">
                        {t("products.title")}
                    </h2>
                    <GoldDivider className="my-7" />
                    <p className="text-sm sm:text-base text-cream/65 font-light max-w-2xl mx-auto leading-relaxed">
                        {t("products.intro")}
                    </p>
                </Reveal>

                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 sm:gap-4" data-testid="products-grid">
                    {names.map((name, i) => (
                        <Reveal key={name} delay={Math.min(i * 0.05, 0.35)}>
                            <div
                                data-testid={`product-tile-${i}`}
                                className="group relative aspect-[4/3] overflow-hidden bg-surface border border-gold/20 rounded-sm hover:border-gold/50 hover:shadow-[0_0_24px_rgba(212,175,55,0.18)] transition-[border-color,box-shadow] duration-300"
                            >
                                <img
                                    src={PRODUCT_IMAGES[i]}
                                    alt={`${name}, Yerberia Jardin D'Venuz, Phoenix`}
                                    loading="lazy"
                                    className="absolute inset-0 w-full h-full object-cover opacity-75 group-hover:opacity-95 group-hover:scale-105 transition-[opacity,transform] duration-500"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/25 to-ink/10 pointer-events-none" aria-hidden="true" />
                                <span className="absolute inset-x-0 bottom-0 p-3 text-center font-accent text-[10px] sm:text-[11px] tracking-[0.18em] uppercase text-gold-soft">
                                    {name}
                                </span>
                            </div>
                        </Reveal>
                    ))}
                </div>

                <Reveal delay={0.2} className="text-center mt-12">
                    <a
                        href={waLink(t("wa.products"))}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="products-whatsapp-button"
                        className="inline-block border border-gold/50 text-gold font-accent text-[10px] tracking-[0.22em] uppercase px-8 py-3.5 rounded-sm hover:bg-gold/10 hover:shadow-[0_0_22px_rgba(212,175,55,0.2)] transition-[background-color,box-shadow] duration-300"
                    >
                        {t("products.cta")}
                    </a>
                </Reveal>
            </div>
        </section>
    );
};
